<template>
    <div class="main-catgories-wrapper">
        <div class="main_categories container">
            <div class="main_categories_items" v-if="categories">
              <CategoryItem v-for="category in categories.slice(0, 11)" :key="category.id" :category="category" />

                <div class="categories_item">
                    <NuxtLink :to="`/categories`" class="category_item">
                        <div class="cate-title">
                            <span class="mini_icon dots-menu">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20.354" height="4.24" viewBox="0 0 20.354 4.24">
                                    <g id="menu-dots" transform="translate(0 -202.667)">
                                        <circle id="Ellipse_24" data-name="Ellipse 24" cx="2.12" cy="2.12" r="2.12" transform="translate(16.114 202.667)"/>
                                        <circle id="Ellipse_25" data-name="Ellipse 25" cx="2.12" cy="2.12" r="2.12" transform="translate(8.057 202.667)"/>
                                        <circle id="Ellipse_26" data-name="Ellipse 26" cx="2.12" cy="2.12" r="2.12" transform="translate(0 202.667)"/>
                                    </g>
                                    </svg>

                            </span>
                            <h1>
                                المزيد
                            </h1>
                        </div>
                        <div class="cate-arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" width="7.272" height="12.136"
                                viewBox="0 0 7.272 12.136">
                                <g id="Group_55448" data-name="Group 55448"
                                    transform="translate(7.272 12.136) rotate(180)">
                                    <g id="previous" transform="translate(7.272 12.136) rotate(180)">
                                        <path id="Path_38383" data-name="Path 38383"
                                            d="M.342,5.206a1.186,1.186,0,0,1,.2-.158l4.7-4.7A1.176,1.176,0,0,1,6.907,2.007L2.856,6.057l4.072,4.072a1.175,1.175,0,1,1-1.662,1.662L.541,7.067a1.22,1.22,0,0,1-.2-1.861Z"
                                            transform="translate(0 0)" fill="#d0d5dc" />
                                    </g>
                                </g>
                            </svg>

                        </div>
                    </NuxtLink>

                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted } from 'vue';

onMounted(() => {
  const boxes = document.querySelectorAll('.category_item');
  boxes.forEach((box, index) => {
    setTimeout(() => {
      box.classList.add('visible');
    }, index * 1500); // Delay increases for each box
  });
});

    defineProps({
        categories: Array
    });
</script>
